/**
 * Excel-Dateien → Text (TSV), damit derselbe Import-Pfad wie bei Copy-Paste
 * greift. SheetJS wird erst beim ersten Bedarf geladen (Bundle-Größe).
 */
export interface SheetText {
  sheets: { name: string; tsv: string }[];
}

export async function spreadsheetToText(file: File): Promise<SheetText> {
  const XLSX = await import('xlsx');
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: 'array', raw: false });
  return {
    sheets: wb.SheetNames.map((name) => {
      const ws = wb.Sheets[name];
      const tsv = ws ? XLSX.utils.sheet_to_csv(ws, { FS: '\t', blankrows: false }) : '';
      return { name, tsv };
    }),
  };
}

export function isSpreadsheet(file: File): boolean {
  return /\.(xlsx|xlsm|xls|ods)$/i.test(file.name);
}
